import { Button, Card, CardBody, CardHeader, Tabs, Tab, Chip } from "@nextui-org/react";
import { ArrowTopRightOnSquareIcon, DocumentCheckIcon } from "@heroicons/react/24/outline";
import useSWR from "swr";
import { getFetcher } from "../../../services/api";
import RootAdmin from "../../../components/layouts/RootAdmin";
import { useMemo, useState, useEffect } from "react";
import FilterReactSelect from "../../../components/elements/FilterReactSelect";
import { month } from "../../../services/enum";
import useListCompany from "../../../hooks/useListCompany";
import { useSelectedCompany } from "../../../hooks/useSelectedCompany";
import { useNavigate } from "react-router-dom";
import { PELAPORAN_DASHBOARD_PATH, REPORT_CONSUMPTION_MATERIAL_INDEX, REPORT_DISTRIBUTION_MATERIAL_INDEX, REPORT_PREVIEW_INDEX, REPORT_PRODUCTION_MATERIAL, REPORT_PURCHASE_MATERIAL_INDEX, REPORT_TRANSPORT_RECOMENDATION_VEHICLE_INDEX } from "../../../services/routes";
import ClientDataGrid from "../../../components/elements/ClientDataGrid";
import toast from "react-hot-toast";

export default function DashboardPage() {
    const navigate = useNavigate()
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    // Perusahaan mengikuti pengguna yang sedang login; super admin tetap bebas memilih.
    const [selectedCompany, setSelectedCompany] = useSelectedCompany();
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [loading, setLoading] = useState(false);
    const { data: dataPeriod, isLoading:  isLoadingPeriod } = useSWR(`/api/period/all`, getFetcher);
    const { dataCompany, isLoadingCompany } = useListCompany()
    const { data: reportedCompanies,isLoading: isLoadingReportedCompanies, mutate: mutateReportedCompanies } = useSWR(
        selectedCompany && selectedPeriod
        ? `api/company/reports-status?returnAll=true&companyIds=${selectedCompany.value}&periodId=${selectedPeriod.value}`
        : null,
        getFetcher
    );
    const { data: reportedApplications, isLoading: isLoadingReportedApplications, mutate: mutateReportedApplications } = useSWR(
        selectedCompany && selectedPeriod
        ? `api/rekom/permohonan/pelaporan/report-status?returnAll=true&companyIds=${selectedCompany.value}&periodId=${selectedPeriod.value}`
        : null, 
        getFetcher
    );
    const { data: reportedRegistrations, isLoading: isLoadingReportedRegistrations, mutate: mutateReportedRegistrations } = useSWR(
        selectedCompany && selectedPeriod
        ? `api/registrasi/pelaporan/report-status?returnAll=true&companyIds=${selectedCompany.value}&periodId=${selectedPeriod.value}`
        : null, 
        getFetcher
    );    

    useEffect(() => {
        if (dataPeriod) {
            const activePeriod = dataPeriod.find((item) => item?.isActive === true);
            if (activePeriod) {
                setSelectedPeriod({ label: activePeriod.name, value: activePeriod.id });
            }
        }
    }, [dataPeriod]);
    
    useEffect(() => {
        const isNotManageB3 = dataCompany?.data?.[0]?.isTidakMelakukanPengelolaanB3;
        if(reportedCompanies && reportedCompanies?.data?.length === 0) {
            isNotManageB3
                ? toast.error('Perusahaan anda tidak melakukan pengelolaan B3')
                : toast.error('Tipe Perusahaan tidak ditemukan, Segera update tipe perusahaan di menu data master perusahaan');
        }

    })
    const columns = useMemo(() => [
        {
            field: 'nomorSurat',
            headerName: 'Nomor Surat',
            renderCell: (params) => <span>{params?.row?.nomor_surat_formatted || '-'}</span>,
        },
        {
            field: 'applicationName',
            headerName: 'Kode Permohonan',
            renderCell: (params) => <span>{params?.row?.kodePermohonan || '-'}</span>,
        },
        {
            field: 'companyName',
            headerName: 'Nama Perusahaan',
            renderCell: (params) => <span>{params?.row?.companyName || '-'}</span>,
        },
        {
            field: 'bulan',
            headerName: 'Bulan',
            valueGetter: (value, row) => month[row?.bulan-1],
            renderCell: (params) => <span>{month[params?.row?.bulan-1] || '-'}</span>,
  
        },
        {
            field: 'tahun',
            headerName: 'Tahun',
            renderCell: (params) => <span>{params?.row?.tahun || '-'}</span>,
  
        },
        {
            field: 'status',
            headerName: 'Status',
            valueGetter: (params) => params.row?.status,
            renderCell: (params) => {
                const status = params.row?.status;

                switch (status) {  
                    case 'Sudah':
                        return (
                            <Chip
                                color="success"
                                variant="flat"
                                size="sm"
                            >
                                {status}
                            </Chip>
                        );
                    case 'Belum Laporan':
                        return (
                            <Chip
                                color="danger"
                                variant="flat"
                                size="sm"
                            >
                                {status}
                            </Chip>
                        )
                    case 'Draft':
                        return (
                            <Chip
                                color="secondary"
                                variant="flat"
                                size="sm"
                            >
                                {status}
                            </Chip>
                        )
                    case 'Menunggu Persetujuan':
                        return (
                            <Chip
                                color="warning"
                                variant="flat"
                                size="sm"
                            >
                                {status}
                            </Chip>
                        )
                    default:
                        return (
                            <Chip
                                color="default"
                                variant="flat"
                                size="sm"
                            >
                                {status}
                            </Chip>
                        );
                }
            }   
        },
        {
            field: 'action',
            headerName: 'Aksi',
            renderCell: (params) => {
                return (
                    <Button isIconOnly size="sm" color="warning"><ArrowTopRightOnSquareIcon className="size-4" /></Button>
                );
            }    
        },
    ], []);

    const columnsPerusahaan = useMemo(() => [
        {
            field: 'companyName',
            headerName: 'Nama Perusahaan',
            renderCell: (params) => <span>{params?.row?.companyName || '-'}</span>,
        },
        {
            field: 'jenisLaporan',
            headerName: 'Jenis Laporan',
            renderCell: (params) => <span>{params?.row?.jenisLaporan || '-'}</span>,
  
        },
        {
            field: 'bulan',
            headerName: 'Bulan',
            valueGetter: (value, row) => month[row?.bulan-1],
            renderCell: (params) => <span>{month[params?.row?.bulan-1] || '-'}</span>,
  
        },
        {
            field: 'tahun',
            headerName: 'Tahun',
            valueGetter: (value, row) => row?.tahun,
            renderCell: (params) => <span>{params?.row?.tahun || '-'}</span>,
  
        },
        {
            field: 'status',
            headerName: 'Status',
            valueGetter: (params) => params.row?.status,
            renderCell: (params) => {
                const status = params.row?.status;

                switch (status) {  
                    case 'Sudah':
                        return (
                            <Chip
                                color="success"
                                variant="flat"
                                size="sm"
                            >
                                {status}
                            </Chip>
                        );
                    case 'Belum Laporan':
                        return (
                            <Chip
                                color="danger"
                                variant="flat"
                                size="sm"
                            >
                                {status}
                            </Chip>
                        )
                    case 'Draft':
                        return (
                            <Chip
                                color="secondary"
                                variant="flat"
                                size="sm"
                            >
                                {status}
                            </Chip>
                        )
                    case 'Menunggu Persetujuan':
                        return (
                            <Chip
                                color="warning"
                                variant="flat"
                                size="sm"
                            >
                                {status}
                            </Chip>
                        )
                    default:
                        return (
                            <Chip
                                color="default"
                                variant="flat"
                                size="sm"
                            >
                                {status}
                            </Chip>
                        );
                }
            }   
        },
        {
            field: 'action',
            headerName: 'Aksi',
            renderCell: (params) => {
                const route = (function () {
                    switch (params.row.jenisLaporan) {
                        case 'Pembelian Bahan B3':
                            return REPORT_PURCHASE_MATERIAL_INDEX;
                        case 'Penggunaan Bahan B3':
                            return REPORT_CONSUMPTION_MATERIAL_INDEX;
                        case 'Distribusi B3':
                            return REPORT_DISTRIBUTION_MATERIAL_INDEX;
                        case 'Produksi B3':
                            return REPORT_PRODUCTION_MATERIAL;
                        case 'Pengangkutan Bahan B3':
                            return REPORT_TRANSPORT_RECOMENDATION_VEHICLE_INDEX;
                        default:
                            return PELAPORAN_DASHBOARD_PATH;
                    }
                })();
                return (
                    <Button onPress={() => navigate(route)} isIconOnly size="sm" color="warning"><ArrowTopRightOnSquareIcon className="size-4" /></Button>
                );
            }    
        },
    ], [navigate]);

    async function handleRefresh() {
        try {
            setLoading(true);
            await new Promise((resolve) => setTimeout(resolve, 1000));
            mutateReportedCompanies();
            mutateReportedApplications();
            mutateReportedRegistrations();
        } catch {
            toast.error('Gagal muat ulang data');
        } finally {
            setLoading(false);
        }
    };

    return (
        <RootAdmin>
            <Card className="w-full" radius="sm">
                <CardHeader>Daftar Pengelolaan & Pengangkutan Belum Di Laporkan</CardHeader>
                <CardBody>
                    <div className="w-full flex justify-end items-center gap-2 mb-3">
                        <div className="w-3/4 flex flex-col justify-end">
                            <div className="flex gap-2">
                                <Button 
                                    size="sm" 
                                    color="warning" 
                                    startContent={ <DocumentCheckIcon className="size-4" color="default" />} 
                                    onPress={() => navigate(REPORT_PREVIEW_INDEX)}
                                >
                                    Preview Laporan
                                </Button>
                            </div>         
                        </div>
                        <div className="w-1/4">
                            <FilterReactSelect
                                defaultValue={selectedCompany}
                                placeholder="Cari Perusahaan"
                                options={dataCompany?.data?.map(item => ({label: item.name, value: item.id}))}
                                isLoading={isLoadingCompany}
                                setValue={setSelectedCompany}
                            />
                        </div>
                    </div>
                    <Tabs 
                        color="primary"
                        variant="underlined"
                        aria-label="tabs"
                        classNames={{
                            tabList: "gap-6 w-full relative rounded-none p-0 border-b border-divider",
                            cursor: "w-full",
                            tab: "max-w-fit px-1.5 h-12",
                            tabContent: "group-data-[selected=true]:font-semibold"
                        }}
                    >
                        <Tab title="Perusahaan" value="reportedCompanies">
                            <div className="h-[500px]">
                                <ClientDataGrid
                                   rows={reportedCompanies?.data}
                                   rowCount={reportedCompanies?.data?.length || 0}
                                   isLoading={isLoadingReportedCompanies}
                                   columns={columnsPerusahaan}
                                   pageSize={pageSize}
                                   setPageSize={setPageSize}
                                   page={page}
                                   setPage={setPage}
                                />
                            </div>
                        </Tab>
                        <Tab title="Rekomendasi" value="reportedApplications">
                            <div className="h-[500px]">
                                <ClientDataGrid
                                    rows={reportedApplications?.data}
                                    rowCount={reportedApplications?.data?.length || 0}
                                    isLoading={isLoadingReportedApplications}
                                    columns={columns}
                                    pageSize={pageSize}
                                    setPageSize={setPageSize}
                                    page={page}
                                    setPage={setPage}
                                />
                            </div>
                        </Tab>
                        <Tab title="Registrasi" value="reportedRegistrations">
                            <div className="h-[500px]">
                                <ClientDataGrid
                                    rows={reportedRegistrations?.data}
                                    rowCount={reportedRegistrations?.data?.length || 0}
                                    isLoading={isLoadingReportedRegistrations}
                                    columns={columns}
                                    pageSize={pageSize}
                                    setPageSize={setPageSize}
                                    page={page}
                                    setPage={setPage}
                                />
                            </div>
                        </Tab>
                    </Tabs>
                </CardBody>
            </Card>
        </RootAdmin>
    );
}
